// extracted by mini-css-extract-plugin
export default {"toggle":"DropdownMenu_toggle__o2DNM","img":"DropdownMenu_img__sAHR5","menu":"DropdownMenu_menu__pkVM+"};